<tagging-search>

    <!-- Normal View -->
    <div class="d-none d-lg-block">
        <tag-selector
                ref="desktop"
                selection-list="{[]}"
                selected-list="{opts.selectedList}"
                scoped-tags="{[]}"
                on-select="{opts.onSelect}"
                ajax="{opts.ajax}"
        ></tag-selector>
    </div>

    <!-- Mobile View -->
    <div class="d-lg-none mr-2" style="display: initial">
        <a href="#" data-toggle="dropdown" id="search-dropdown">
            <i class="fa fa-search"></i>
        </a>

        <div class="dropdown-menu w-100 pl-2 pr-2" aria-labelledby="search-dropdown">
            <tag-selector
                    ref="mobile"
                    selection-list="{[]}"
                    selected-list="{opts.selectedList}"
                    scoped-tags="{[]}"
                    on-select="{opts.onSelect}"
                    ajax="{opts.ajax}"
            ></tag-selector>
        </div>
    </div>


    <script>

        import '../tag-selector/tag-selector.tag.html'

        const tag = this;


        tag.getValues = () => {
            return [...tag.refs.mobile.getValues(), ...tag.refs.desktop.getValues()]
        }

    </script>
</tagging-search>


// WEBPACK FOOTER //
// avr_eshop/frontend/components/nav-bar/tag-search.tag.html